import { render, staticRenderFns } from "./CakeGroupChoice.vue?vue&type=template&id=ba74daec&"
import script from "./CakeGroupChoice.vue?vue&type=script&lang=js&"
export * from "./CakeGroupChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports